import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  certificateUI: ""
};

export const certificateUISlice = createSlice({
  name: 'certificateUI',
  initialState,
  reducers: {
    setCertificateUISlice: (state, action: PayloadAction<any>) => {
      state.certificateUI = action.payload;
    }
  }
});

export const { setCertificateUISlice } = certificateUISlice.actions;

export default certificateUISlice.reducer;
